import React from 'react';
import CardTable from '../CardTable';
import styles from '../card.module.css';

/* Вкладка «Подчинённые подразделения» (п. 6 ТЗ): за факультетом числятся не
   только кафедры, отсюда и название. Код приходит строкой и бывает длиной до
   сорока знаков — он переносится внутри ячейки и вёрстку не ломает. */

const COLUMNS = [
  { key: 'code', title: 'Код', cell: row => row.code, className: styles.mono },
  { key: 'name', title: 'Подразделение', cell: row => row.name, className: styles.lead },
  { key: 'shortname', title: 'Сокращение', cell: row => row.shortname },
  { key: 'chief', title: 'Руководитель', cell: row => row.chief },
];

const Departments = ({ data }) => (
  <CardTable
    columns={COLUMNS}
    rows={data.items}
    rowKey={row => row.id}
    counter={<>Всего записей: <b>{data.count}</b></>}
    emptyTitle="Подчинённых подразделений нет"
    emptyText="За факультетом не закреплено ни одной кафедры или отдела"
  />
);

export default Departments;
